import MyContainer from "@/components/MyContainer";
import MessageTemplateForm from "@/pages/message-template/form/message-template-form";
import { useGetMessageTemplate } from "@/services/message-template-service";
import { Box } from "@mui/material";
import { useParams } from "wouter";

export function EditMessageTemplate() {
  const params = useParams();
  const messageTemplateId = params.id?.toString();

  if (!messageTemplateId) {
    return (
      <MyContainer
        title="Edit Message Template"
        subtitle="Edit message template"
      >
        <div>Message template not found</div>
      </MyContainer>
    );
  }

  const { data: initialValues, isLoading } =
    useGetMessageTemplate(messageTemplateId);

  if (isLoading) {
    <MyContainer title="Edit Message Template" subtitle="Edit message template">
      <Box sx={{ p: 2, color: "text.secondary" }}>Loading…</Box>
    </MyContainer>;
  }

  if (!initialValues) {
    return (
      <MyContainer
        title="Edit Message Template"
        subtitle="Edit message template"
      >
        <Box sx={{ p: 2, color: "text.secondary" }}>
          Message template not found
        </Box>
      </MyContainer>
    );
  }

  return (
    <MyContainer title="Edit Message Template" subtitle="Edit message template">
      <MessageTemplateForm mode="update" initialValues={initialValues} />
    </MyContainer>
  );
}
